module.exports = __webpack_public_path__ + "static/media/badge-missing.6a0b0742.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default/badge-missing.png
// module id = 184
// module chunks = 0